import { z } from "zod";

export enum HpAssigneeUnresolvedReason {
  NO_ASSIGNMENT = "no_assignment",
  ROSTER_GAP = "roster_gap",
}

export const hpAssigneeResolutionSchema = z.discriminatedUnion("resolved", [
  z.object({ resolved: z.literal(true), staffId: z.string() }),
  z.object({ resolved: z.literal(false), reason: z.nativeEnum(HpAssigneeUnresolvedReason) }),
]);

export type HpAssigneeResolution = z.infer<typeof hpAssigneeResolutionSchema>;
